import React from 'react';
import { Check, Heart } from 'lucide-react';
export function SymptomsSection() {
  return <section className="py-20 px-4 bg-rose-50/50" data-id="element-169">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-start" data-id="element-170">
        {/* Left Column: Symptoms Checklist */}
        <div className="bg-white p-8 rounded-3xl shadow-sm border border-violet-100" data-id="element-171">
          <h2 className="text-3xl font-bold text-violet-900 mb-8" data-id="element-172">
            ¿ESTO TE ESTÁ PASANDO?
          </h2>

          <ul className="space-y-4 mb-8" data-id="element-173">
            {['Tu pareja se alejó sin explicación', 'Sientes que el amor se enfrió', 'Te duele verla(o) con alguien más', 'La comunicación se rompió', 'Has intentado de todo sin resultados', 'No logras soltar, aunque diga que ya no quiere nada'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-174">
                <div className="bg-violet-100 p-1 rounded-full mt-0.5" data-id="element-175">
                  <Check className="w-4 h-4 text-violet-700" data-id="element-176" />
                </div>
                <span className="text-lg text-gray-700" data-id="element-177">{item}</span>
              </li>)}
          </ul>

          <div className="bg-violet-50 p-4 rounded-xl border border-violet-200 text-center" data-id="element-178">
            <p className="text-violet-900 font-medium" data-id="element-179">
              👉 Si te identificas con al menos uno, este mensaje es para ti.
            </p>
          </div>
        </div>

        {/* Right Column: Expert Benefits */}
        <div className="space-y-8" data-id="element-180">
          <div data-id="element-181">
            <div className="flex items-center gap-3 mb-6" data-id="element-182">
              <Heart className="w-8 h-8 text-rose-500 fill-current" data-id="element-183" />
              <h2 className="text-3xl font-bold text-rose-900" data-id="element-184">
                EXPERTOS EN LAZOS DE AMOR
              </h2>
            </div>
            <p className="text-xl text-gray-600 mb-6" data-id="element-185">Te ayudamos a:</p>
          </div>

          <ul className="space-y-6" data-id="element-186">
            {['Sanar el vínculo energético', 'Eliminar bloqueos emocionales', 'Restaurar la conexión perdida', 'Reavivar el sentimiento desde el respeto', 'Fortalecer el amor con estabilidad y claridad'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-187">
                <div className="w-12 h-1 bg-rose-500 rounded-full" data-id="element-188" />
                <span className="text-xl text-gray-800 font-medium" data-id="element-189">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="pt-8 border-t border-gray-200" data-id="element-190">
            <p className="text-gray-600 leading-relaxed italic" data-id="element-191">
              Todo mediante rituales personalizados, guiados paso a paso,
              enfocados únicamente en el amor, sin dañar, sin forzar y sin
              consecuencias negativas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}